var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications',{attrs:{"position":"top center","group":"info"}}),_c('h1',[_vm._v("Bande passante")]),(_vm.bandwidth)?_c('BarChart',{attrs:{"chartData":_vm.bandwidth}}):_vm._e(),(_vm.bandwidth)?_c('div',[_vm._v("Total : "+_vm._s(_vm.bandwidth_sum.toFixed(2))+" mo")]):_vm._e(),(_vm.editor_bandwidth)?_c('BarChart',{attrs:{"chartData":_vm.editor_bandwidth}}):_vm._e(),(_vm.editor_bandwidth)?_c('div',[_vm._v("Total : "+_vm._s(_vm.editor_bandwidth_sum.toFixed(2))+" mo")]):_vm._e(),_c('h1',[_vm._v("Opération sur le client")]),_c('b-button',{on:{"click":_vm.generate_last_treatments}},[_vm._v("Générer les derniers traitements par projets")]),_c('h1',[_vm._v("Stats générales")]),_c('b-form-select',{attrs:{"options":_vm.clients_name},on:{"change":_vm.getClients},model:{value:(_vm.client),callback:function ($$v) {_vm.client=$$v},expression:"client"}}),(_vm.print)?_c('div',[_c('h2',[_vm._v("Worker")]),(_vm.steps)?_c('div',[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.steps,"fields":[
					{
						key: 'name',
						label: 'Nom',
						sortable: true
					},
					{
						key: 'value',
						label: 'Occurences',
						sortable: true
					}
				]}})],1):_vm._e(),(_vm.steps_scenario)?_c('div',[_c('h2',[_vm._v("Etapes - scénarios")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.steps_scenario,"fields":[
					{
						key: 'studio_name',
						label: 'Nom',
						sortable: true
					},
					{
						key: 'worker',
						label: 'Worker',
						sortable: true
					},
					{
						key: 'value',
						label: 'Occurences',
						sortable: true
					}
				]}})],1):_vm._e(),_c('h2',[_vm._v("Projets clients")]),_vm._l((_vm.clients),function(client,idx){return _c('div',{key:idx},[(client.projects)?_c('div',[_c('h3',[_vm._v(_vm._s(client.nom))]),_c('b-table',{attrs:{"striped":"","hover":"","items":client.projects,"fields":[
						{
							key: 'libelle',
							label: 'Nom',
							sortable: true
						},
						{
							key: 'last_treatment',
							label: 'Date du dernier traitement',
							sortable: true,
							sortByFormatted: true,
							formatter: (value, key, item) => {
								return item.last_treatment ? item.last_treatment.dateheure_debut : 0;
  							},
						},
						{
							key: 'scenario',
							label: 'Scenario',
							sortable: true,
							sortByFormatted: true,
							formatter: (value, key, item) => {
								return item.scenario ? true : false;
  							},
						}
					]},scopedSlots:_vm._u([{key:"cell(last_treatment)",fn:function(data){return [_c('span',[_vm._v(_vm._s(data.item.last_treatment ? _vm.moment(data.item.last_treatment.dateheure_debut).format("LL") : ""))])]}},{key:"cell(index)",fn:function(data){return [_c('i',{staticClass:"fa fa-times close",on:{"click":function($event){return _vm.remove_mapping(data.index)}}})]}},{key:"cell(scenario)",fn:function(data){return [_c('span',[_vm._v(_vm._s((data.item && data.item.scenario) ? "oui" : "non"))])]}}],null,true)})],1):_vm._e()])})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }